import { Tag, Tooltip } from "antd";
import { TFeatureWorkflowInstance } from "entity-app/models";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ComputeStrategy } from "components/workflow-template-editor/model";

function EntityLeadTimeView(props: {
  featureWorkflowInstance: TFeatureWorkflowInstance;
  materialHeaderMap?: any;
}) {
  const { featureWorkflowInstance, materialHeaderMap } = props;
  if (!featureWorkflowInstance) return null;
  const leadTime =
    featureWorkflowInstance?.feature_workflow_instance?.lead_time;
  const hasLeadTime = leadTime !== null && leadTime !== undefined;
  let dayPlaceholder: "day" | "days" | undefined;
  if (hasLeadTime) {
    const numericLeadTime = Number(leadTime);
    dayPlaceholder = numericLeadTime > 1 ? "days" : "day";
  }

  const computeStrategy =
    featureWorkflowInstance?.feature_workflow_instance
      ?.project_workflow_template?.dateblock_compute_strategy?.key;

  const isLeadTimeUnavailable =
    computeStrategy === ComputeStrategy.COMMITTED_DATE_DRIVEN && !hasLeadTime;

  const tooltipTitle = isLeadTimeUnavailable
    ? "Lead Time is not available because some Durations cannot be computed. Enter the Committed Dates for all Milestones to generate the Durations and Lead Time."
    : "In Calendar days, including weekends and holidays.";

  return (
    <div className="flex space-x-2 items-center text-ciq-gray-950 text-opacity-80 text-sm font-medium">
      <div>{materialHeaderMap?.lead_time ?? ""}:</div>
      <Tag className="rounded">
        <div className="flex space-x-2 items-center">
          <div className="space-x-[1px] text-black text-opacity-90 font-normal">
            <span>{hasLeadTime ? leadTime : "-"}</span>
            {hasLeadTime && dayPlaceholder && (
              <span className="italic">{dayPlaceholder}</span>
            )}
          </div>
          <Tooltip
            title={tooltipTitle}
            className="cursor-default"
            styles={{
              root: {
                maxWidth:
                  computeStrategy === ComputeStrategy.DURATION_DRIVEN
                    ? "150px"
                    : "300px"
              }
            }}
          >
            <InfoCircleOutlined style={{ color: "gray" }} />
          </Tooltip>
        </div>
      </Tag>
    </div>
  );
}

export default EntityLeadTimeView;
